import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import { makeQueryClient } from './lib/query'
import './styles.css'

/**
 * One client for the page, made here rather than in a component.
 *
 * A client built during render would be a new cache on every render, which is
 * an empty one: the point of it is to outlive them.
 *
 * `query.ts` was written when the record layer was built and nothing had ever
 * mounted it, so the first thing to call `useQuery` brought the whole app down
 * with "No QueryClient set". A module with no callers looks exactly like a
 * finished one, which is the fourth time that has been true in this app.
 */
const queryClient = makeQueryClient()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
)
